import { createI18n } from 'vue-i18n'
import type { ContactMeWidgetOptions, SupportedLocale } from '../types'
import { detectLocale } from './detect'
import { messages } from './messages'

export function resolveLocale(options?: ContactMeWidgetOptions): SupportedLocale {
  const lang = options?.lang
  if (!lang || lang === 'auto') return detectLocale()
  return lang
}

export function createWidgetI18n(options?: ContactMeWidgetOptions) {
  const locale = resolveLocale(options)
  return createI18n({
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale: 'en',
    messages,
  })
}
